import React, { FunctionComponent } from 'react';
import { IDoughnutMetricCardProps } from './types';
import DoughnutChart from '../../../common/charts/DoughnutChart';
import { InfoIconPopup } from '../../../common/InfoIconPopup';

const DoughnutMetricCard: FunctionComponent<IDoughnutMetricCardProps> = ({
  title,
  description,
  totalLabel,
  total,
  segments,
  showIncomplete = true,
  incompleteLabel = 'Incomplete',
}) => {
  const segmentsTotal = segments.reduce((prev, curr) => (prev = prev + Number(curr.value)), 0);
  const incompleteRate = total > 0 ? Math.max(total - segmentsTotal, 0) : 0;
  const completionRate = total > 0 ? Math.round((segmentsTotal / total) * 100) : null;

  if (showIncomplete) {
    segments.push({ label: incompleteLabel, value: incompleteRate, color: 'red' });
  }

  const chartSegments = segments
    .map((segment) => ({
      color: segment.color,
      value: segment.value,
    }))
    .reverse();

  const labelSegments = segments.map((segment) => ({
    label: segment.label,
    color: segment.color,
    value: segment.value,
  }));

  return (
    <div className="item panel flex-column flex p-2 align-center">
      <div className="flex mr-auto align-center">
        <h2>{title}</h2>
        {description && (
          <InfoIconPopup>
            <p>{description}</p>
          </InfoIconPopup>
        )}
      </div>
      <div className="flex align-center w100">
        <div style={{ position: 'relative', width: 120, height: 120 }}>
          <DoughnutChart segments={chartSegments} completionRate={completionRate} />
        </div>
        <div className="flex flex-column ml-2" style={{ flex: 1 }}>
          <div className="flex align-center justify-between border-bottom py-1">
            <div className="text-left">{totalLabel}:</div>
            <div className="flex">
              <div className="bold text-left mr-1">{total.toLocaleString()}</div>
              <div style={{ width: 60 }}></div>
            </div>
          </div>
          {labelSegments.map((segment) => (
            <div className="flex align-center justify-between py-1" key={segment.label}>
              <div className="text-left">{segment.label}:</div>
              <div className="flex">
                <div className={`${total ? segment.color : ''} bold mr-1`}>{segment.value.toLocaleString()}</div>
                <div className="flex" style={{ width: 60 }}>
                  |
                  <div className={`${total ? segment.color : ''} bold text-right`} style={{ width: 50 }}>
                    {total !== 0 ? ((segment.value / total) * 100).toFixed(1) : 0} %
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default DoughnutMetricCard;
